export default {
  assignees: state => state.assignees || {},
  loggedInUserDetail: state => state.loggedInUserDetail || {},
};
